/**
 * 通用分类页头部组件
 */
import React from 'react'
import './index.less'
import { CommonClassHeaderModel } from '@/controller/global/InitHeader'
import DFImage from '../../DFImage'
const CommonClassHeaderPart = (props: CommonClassHeaderModel) => {
  const changeDiv = (url?: string) => {
    if (url) {
      window.df_sdk_common.location.href = url
    }
  }

  return (
    <div className="common-classification">
      {props?.leftBackIcon && props?.leftBackShow && (
        <div
          className="common-classification-left"
          onClick={() => {
            changeDiv(props?.leftBackUrl)
          }}
        >
          <DFImage src={props?.leftBackIcon} />
          {props?.leftBackText && <div>{props?.leftBackText}</div>}
        </div>
      )}

      <div className="common-classification-title">
        {props?.contentText && <div>{props?.contentText}</div>}
      </div>

      {props?.rightSearchShow && props?.rightSearchIcon && (
        <div
          className="common-classification-right"
          onClick={() => {
            changeDiv(props?.rightSearchUrl)
          }}
        >
          <div>
            <DFImage src={props?.rightSearchIcon} />
          </div>
          {props?.rightSearchText && <div>{props?.rightSearchText}</div>}
        </div>
      )}
    </div>
  )
}

export default CommonClassHeaderPart
